import React from 'react';
import styled from 'styled-components';
import { Colors, Spacing } from '../../constants';
import { Button as FztButton } from '../Button';
import Modal from './Modal';
import { Box } from '../Box';
import { IcImportantNote } from '../../icons';
import { Text } from '../Text';

interface DeleteModalProps {
  isOpen: boolean;
  title?: string;
  description?: string;
  labelCancel?: string;
  labelConfirm?: string;
  onClose: () => void;
  onConfirm: () => void;
}

const ButtonGroup = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-around;
  flex: 1;
  gap: ${Spacing[8]};
`;

const Button = styled(FztButton)`
  flex: 1;
`;

const DeleteModal: React.FC<DeleteModalProps> = ({
  isOpen,
  title = 'DELETE',
  description = 'Do you want remove this ?',
  labelCancel = 'Cancel',
  labelConfirm = 'Delete',
  onClose,
  onConfirm,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onCancel={onClose}
      title={title}
      closeOnClickOutside={false}
      width={700}
      footer={null}
    >
      <Box
        display='flex'
        flexDirection='column'
        justifyContent='center'
        alignItems='center'
        padding={24}
        gap={40}
      >
        <IcImportantNote width={100} height={100} fill={Colors.yellow[2]} />
        <Text title_h5 semibold>
          {description}
        </Text>
        <ButtonGroup>
          <Button type_cancel onClick={onClose} style={{ width: '100%' }}>
            {labelCancel}
          </Button>
          <Button type_primary onClick={onConfirm} style={{ width: '100%' }}>
            {labelConfirm}
          </Button>
        </ButtonGroup>
      </Box>
    </Modal>
  );
};

export default DeleteModal;
